import { render } from "./AdminHome.vue?vue&type=template&id=6d75d702&scoped=true&ts=true"
import script from "./AdminHome.vue?vue&type=script&lang=ts"
export * from "./AdminHome.vue?vue&type=script&lang=ts"

import "./AdminHome.vue?vue&type=style&index=0&id=6d75d702&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d75d702"]])

export default __exports__